import { IconEyeDollar } from '@tabler/icons-react';
import { i18nKeys, useTranslation } from 'locales';
import { mergeWith, subtract } from 'lodash-es';
import { clone, isNonNullish } from 'remeda';
import { useLoadActionableInvoices } from 'shared/hooks/use-load-actionable-invoices';
import {
  type AgedBalanceCompact,
  useLoadAgedBalanceCompact,
} from 'shared/hooks/use-load-aged-balance';
import { useSafeLocalizedCompactCurrencyFormatter } from 'shared/utils/currency';

import { BaseTicker } from '../BaseTicker';

function getShareActionable(agedBalanceCompact: AgedBalanceCompact, actionableInvoices: number) {
  const netAgedBalance = mergeWith(
    clone(agedBalanceCompact.debits),
    agedBalanceCompact.credits,
    subtract,
  );

  const totalReceivable =
    netAgedBalance.notDue +
    netAgedBalance['0'] +
    netAgedBalance['30'] +
    netAgedBalance['60'] +
    netAgedBalance['90'];

  return actionableInvoices / totalReceivable;
}

export const ActionableTicker = () => {
  const { t } = useTranslation();
  const { agedBalanceCompact, agedBalanceCompactError, isAgedBalanceCompactLoading } =
    useLoadAgedBalanceCompact();
  const { actionableInvoices, actionableInvoicesError, isActionableInvoicesLoading } =
    useLoadActionableInvoices();
  const formatter = useSafeLocalizedCompactCurrencyFormatter();

  if (
    isAgedBalanceCompactLoading ||
    agedBalanceCompact == null ||
    isActionableInvoicesLoading ||
    actionableInvoices == null
  ) {
    return (
      <BaseTicker
        icon={IconEyeDollar}
        label={t(i18nKeys.ANALYTICS.TICKERS.ACTIONABLE.TITLE)}
        hasFailed={isNonNullish(agedBalanceCompactError) || isNonNullish(actionableInvoicesError)}
      />
    );
  }

  return (
    <BaseTicker
      icon={IconEyeDollar}
      label={t(i18nKeys.ANALYTICS.TICKERS.ACTIONABLE.TITLE)}
      value={formatter.format(actionableInvoices)}
      share={getShareActionable(agedBalanceCompact, actionableInvoices)}
      url="/invoices/to-handle"
    />
  );
};
